import { HorizontalNavigationTab } from "@risalabs_frontend_org/oasis-ui-kit";
import { NarAgentGridOrgTab } from "../hooks/useNarAgentGridOrgTabs";

export interface NarAgentGridOrgTabsProps {
  tabs: NarAgentGridOrgTab[];
  loading: boolean;
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

/**
 * Org tab strip for the NAR Agent Grid page.
 */
const NarAgentGridOrgTabs = ({
  tabs,
  loading,
  activeTab,
  onTabChange,
}: NarAgentGridOrgTabsProps) => (
  <div className="nar-agent-grid--tabs mb-4 border-b border-primaryGray-14">
    {loading ? (
      <div className="px-4 py-2 text-sm text-primaryGray-6">
        Loading organizations…
      </div>
    ) : (
      <HorizontalNavigationTab
        tabs={tabs.map((tab) => ({
          label: tab.label,
          value: tab.id,
        }))}
        value={activeTab}
        onChange={onTabChange}
        backgroundColor="none"
      />
    )}
  </div>
);

export default NarAgentGridOrgTabs;
